
export default function SecurityPrivacy() {
  const securityFeatures = [
    {
      title: 'No-Logs Policy',
      description: 'We never track, collect, or store your online activity. Your browsing history remains completely private.'
    },
    {
      title: 'Kill Switch Protection',
      description: 'Automatically blocks all internet traffic if your VPN connection drops, preventing data leaks.'
    },
    {
      title: 'DNS Leak Prevention',
      description: 'Our built-in DNS leak protection ensures your DNS queries are always encrypted and secure.'
    },
    {
      title: 'Split Tunneling',
      description: 'Choose which apps use the VPN connection and which use your regular internet connection.'
    }
  ];

  return (
    <section id="security" className="py-32 bg-slate-900">
      <div className="max-w-7xl mx-auto px-8">
        <div className="flex items-center gap-16">
          <div className="w-1/2">
            <div className="relative">
              <img
                src="https://public.readdy.ai/ai/img_res/b34eb670c15f83c6a383348b62dc4f57.jpg"
                alt="Security Visualization"
                className="w-full h-full object-cover object-top rounded-3xl"
              />
            </div>
          </div>

          <div className="w-1/2 pl-12">
            <p className="text-sm text-cyan-400 uppercase tracking-widest mb-6 whitespace-nowrap">SECURITY FIRST</p>
            
            <h2 className="text-5xl font-extrabold text-white leading-tight mb-10">
              Your Privacy Is<br />
              Our Top<br />
              Priority
            </h2>

            <div className="space-y-8">
              {securityFeatures.map((feature, index) => (
                <div key={index} className="flex gap-4">
                  <div className="flex-shrink-0 w-6 h-6 flex items-center justify-center mt-1">
                    <i className="ri-checkbox-circle-fill text-2xl text-cyan-400"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-white mb-2 whitespace-nowrap">{feature.title}</h3>
                    <p className="text-gray-300 text-base leading-relaxed">
                      {feature.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            <button className="mt-16 px-10 py-4 bg-gradient-to-r from-cyan-400 to-blue-500 text-white rounded-xl font-medium hover:shadow-lg transition-all whitespace-nowrap">
              View Security Details
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
